<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <router-link :to="{ name: 'New product' }" class="mt-2 mb-0 btn bg-gradient-success ms-lg-3 me-lg-0 me-auto mt-lg-0 "><span>{{ $t('key_productList_new_record') }}</span></router-link>
                  <hk-btn-upload-modal :options-format="formatsFile" :url="urlUpload" @success="importSuccess" @failure="importFailure"/>
                  <Filter :filter-status-selected="filterStatusSelected" @filter-change="onFilterChange"/>
                  <soft-button class="btn-icon ms-2 export" size color="primary" variant="outline" data-type="csv" @click="onDownloadExcel">
                    <span class="btn-inner--icon">
                      <i class="ni ni-archive-2"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_export') }}</span>
                  </soft-button>
                  <!-- Interactions with database (filters and reload) -->
                  <ReloadButton :title="$t('key_batchUploadListTableHeader_button_reload_batchUpload')" @change="getProducts"/>
                </div>
              </div>
              <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <!-- Search space -->
                  <Searchbox :list-filters="listFilters" @change="onSearchChange"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla con los Datos -->
          <GenericTable
            v-if="!!productsData"
            ref="genericTable"
            :items="productsData.items"
            :list-filters="listFilters"
            :pagination="pagination"
            :headers="headers"
            :is-loading="isLoading"
            @header-changed="onHeaderChange"
            @changed-page="paginationPageChange"
            @row-change="paginationRowChange">
            <template #row="product">
              <td class="text-xs" style="width: 15rem">
                <div class="d-flex">
                  <div class="d-lg-flex">
                    <div>
                      <img class="d-inline" :class="!product.image? 'noimageColor': 'image'"  :src="!product.image? noimage: product.image" :alt="$t('key_products_image')" />
                    </div>
                    <div class="my-auto mt-4 ms-auto mt-lg-0">
                      <h6 class="my-2 ms-3">
                        <a class="text-xs font-weight-bold text-primary" href="#" @click.prevent="goToEditar(product)">
                          {{ product.name }}
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ product.family }}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ product.subfamily }}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ product.season }}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="product.batch_control" class="badge badge-info badge-sm">{{ this.$t('key_productList_batchControl') }}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="product.batch_control_date" class="badge badge-info badge-sm">{{ this.$t('key_productList_batchControlDate') }}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="product.status == 'REGISTRADO'" class="badge badge-saved badge-sm">{{ $t('key_productsList_productSaved') }}</span>
                <span v-else class="badge badge-error badge-sm" :title="product.errors">{{ $t('key_productsList_productError') }}</span>
              </td>
            </template>
          </GenericTable>
          <!-- <Configurator>
            <p>Aquí puedes meter contenido personalizado como filtros, controles, o información extra.</p>
          </Configurator> -->
        </div>
      </div>
    </div>
  </div>
  <div class="position-fixed top-8 end-2 z-index-2">
    <soft-snackbar
      :show="showNotification"
      :title="notificationInfo.title"
      :description="notificationInfo.message"
      :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
      :color="notificationInfo.status=='success'?'success':'danger'"
      @close-handler="showNotification = !showNotification"
    />
  </div>
</template>

<script>

  import { mapMutations } from "vuex";
  import GenericTable from "./../../picko_components/generic_components/GenericTable.vue";
  import ReloadButton from "./../../picko_components/generic_components/ReloadButton.vue";
  import Searchbox from "./../../picko_components/generic_components/Searchbox.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import { HkBtnUploadModal } from "@/hotaka/components";
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import Filter from "./components/Filter.vue";
  import noimage from  "@/assets/img/sevica-images/noimage.png";
  import Cookies from 'js-cookie';



  /* import Configurator from "./../../examples/Configurator3.vue"; */

  const body = document.getElementsByTagName("body")[0];

  export default {
    name: "ProductsList",
    components: {
      SoftButton,
      HkBtnUploadModal,
      SoftSnackbar,
      Filter,
      GenericTable,
      ReloadButton,
      Searchbox,

      /* Configurator */
    },
    data()  {
      return{
        filterStatusSelected: '',
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50]
        },
        formatsFile:[
          { label: 'Sevica',value: 'SEVICA'},        
        ],
        urlUpload:"/products/batch",
        notificationInfo:{
          title: '',
          message: '',
          status: 'danger'
        },
        showNotification: false,
        isLoading: false,
        filters:{
          search: '',
          status:'',
          sort:{
            sort:'',
            order:''
          }
        },
        noimage
      }
    },
    computed: {
      productsData() {
        return this.$store.state.products.list.data;
      },
      productsExcel() {
        return this.$store.state.products.productsExcel.data;
      },
      listFilters() {
        return this.$store.state.products.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_products'), sort: { sorteable: true, order: "" }, column: "name" },
          { title: this.$t('key_theader_family'), sort: { sorteable: true, order: "" }, column: "family" },
          { title: this.$t('key_theader_subfamily'), sort: { sorteable: true, order: "" }, column: "subfamily" },
          { title: this.$t('key_theader_season'), sort: { sorteable: true, order: "" }, column: "season" },
          { title: this.$t('key_theader_batch_control'), sort: { sorteable: true, order: "" }, column: "batch_control" },
          { title: this.$t('key_theader_batch_control_date'), sort: { sorteable: true, order: "" }, column: "batch_control_date" },
          { title: this.$t('key_theader_status'), sort: { sorteable: true, order: "" }, column: "status" }
        ]
      },
      title() {
        return this.$t('key_productList_table_title');
      },
      description() {
        return this.$t('key_productList_table_description');
      }
    },
    watch: {
      productsData() {
        if(this.productsData){
          this.pagination.total= this.productsData.total;
          this.isLoading = false;
        }
      },
      productsExcel() {
        if (this.$store.state.products.productsExcel.error) {
          const error = this.$store.state.products.productsExcel.error;
          const fr = new FileReader();
          fr.onload = (e) => {
            let excelError = JSON.parse(e.target.result);
            this.notificationInfo = {
              title: 'Ups! Error',
              message: excelError,
              status: 'error'
            }
            this.showNotification = true;
            this.closeNotification();
          };
          fr.readAsText(error);
        }
        else{
          this.downloadExcel(this.productsExcel);
          return;
        }
      },
    },
    mounted() {
      this.setUpFilters()
      if (Object.keys(this.$route.query).length > 0) {
        this.filterStatusSelected = this.$route.query.status
        this.filters.status = this.$route.query.status;
      }
      this.getProducts();
    },
    created() {
      //this.toggleHideConfig();
      //this.toggleConfigurator();
      body.classList.remove("bg-gray-100");
    },
    beforeUnmount() {

      //this.toggleHideConfig();
      body.classList.add("bg-gray-100");
    },
    methods: {
      ...mapMutations(["showConfig"]),
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }
        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters.filters)) }
        this.pagination = { ...this.listFilters.pagination }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      getProducts() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("products/load",{
          filters: this.filters,
          pagination:this.pagination
        });
      },
      goToEditar(product){
        this.$router.push({ path: "/MasterData/Products/EditProduct/" + product._id});
      },
      importSuccess(){
        this.notificationInfo={
          title: this.$t('key_mheader_products_sent'),
          message: this.$t('key_mmessage_products_sent'),
          status: 'success'
        }
        this.showNotification = true;
        this.closeNotification();
        setTimeout(() => {
          this.getProducts();
        }, 3000)
      },
      importFailure(){
        this.notificationInfo = {
          title: this.$t('key_mheader_import_failed'),
          message: this.$t('key_mheader_import_failed'),
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      },
      closeNotification(){
        const self= this;
        setTimeout(function () {
            self.showNotification = false
        },2700);
      },
      onSearchChange(value){
        this.pagination.currentPage = 1;
        this.filters.search=value;
        this.getProducts(); 
      },
      onFilterChange(value){
        this.filterStatusSelected = value
        this.filters.status=value;
        this.getProducts(); 
      },
      paginationPageChange(page) {
        this.pagination.currentPage = page;
        this.getProducts(); 
      },
      paginationRowChange(rows) {
        this.pagination.rows = rows;
        this.getProducts(); 
      },
      onDownloadExcel(){
        let savedLanguage = Cookies.get('Picko.language') || 'en';
        this.$store.commit("products/productsExcel", {filters: this.filters, language: savedLanguage});
      },
      downloadExcel(blob) {
        const link = document.createElement("a");
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        link.setAttribute('download', `Products-${formattedDate}`);
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
            URL.revokeObjectURL(link.href);
        }, 100);
      },
      onHeaderChange(val){
        this.filters.sort={
          sort: val.column,
          order: val.order=='asc'? "ascending": "descending"
        }
        this.getProducts(); 
      }
    }
  };

</script>

<style scoped>

  .columns {
    max-width: 150px;
  }
  
  .image{
    height: 2.2rem !important;
    border-radius: 9%;
  }

  .overflow-column {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pointer {
    cursor: pointer;
  }

</style>
